import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';

export const TaxDiagnosticHeaderLottie = ({ src }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (<LottieControl
    src={src}
    onLoadSuccess={() => setIsContentShowing(true)}
    onLoadError={() => setIsContentShowing(true)}
    width={'auto'}
    height={'64px'}
  />);
};

TaxDiagnosticHeaderLottie.propTypes = {
  src: PropTypes.string.isRequired,
};
